import React from "react";
import Swal from "sweetalert2";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import moment from "moment";
import "moment/locale/id";
import { getAllProfile, updateFotoProfile } from "stores";
import { useDispatch, useSelector } from "react-redux";
import "./UserProfile.css";
// import { ImageCompressor } from "image-compressor";
// import { compress } from "image-compressor";

function UserProfile() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const user = useSelector((state) => state.userReducer);

  const [profileUser, setProfileUser] = React.useState([]);
  const [showPhotoModal, setShowPhotoModal] = React.useState(false);
  const [profilePhoto, setProfilePhoto] = React.useState("");
  const [profilePhotoVersion, setProfilePhotoVersion] = React.useState(Date.now());
  const [photoDraft, setPhotoDraft] = React.useState("");
  const [photoFile, setPhotoFile] = React.useState(null);

  React.useEffect(() => {
    let tmp =
      user.userProfile &&
      user.userProfile.data &&
      user.userProfile.data.map((val, index) => {
        return {
          ...val,
        };
      });
    setProfileUser(tmp);
  }, [user.userProfile]);

  React.useEffect(() => {
    getAllProfile(dispatch);
  }, []);

  React.useEffect(() => {
    setProfilePhoto(
      profileUser?.[0]?.foto ||
        profileUser?.[0]?.fotoProfile ||
        profileUser?.[0]?.photo ||
        "",
    );
    setProfilePhotoVersion(Date.now());
  }, [profileUser, auth.nopeg]);

  const profile = profileUser?.[0] || {};
  const profileName = auth.nama || profile.nama || "Pengguna";
  const koperasiStatus =
    profile.statusKoperasi === "active"
      ? "Aktif"
      : profile.statusKoperasi === "nonactive"
        ? "Tidak Aktif"
        : profile.statusKoperasi === "waiting"
          ? "Menunggu"
          : profile.statusKoperasi === "exit"
            ? "Keluar"
            : "-";
  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const numericValue = Number(value);
    return Number.isNaN(numericValue)
      ? value
      : numericValue.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
  };

  const handlePhotoChange = (event) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.size > 1024 * 1024) {
      Swal.fire("Ukuran foto terlalu besar", "Ukuran foto maksimal 1 MB", "warning");
      event.target.value = "";
      return;
    }

    setPhotoFile(selectedFile);
    const reader = new FileReader();
    reader.onload = () => setPhotoDraft(reader.result);
    reader.readAsDataURL(selectedFile);
  };

  const handleSavePhoto = async () => {
    if (!photoDraft || !photoFile) return;

    const formData = new FormData();
    formData.append("foto", photoFile);

    try {
      const response = await updateFotoProfile(formData);
      if (!response || response.status !== 200) {
        throw new Error(response?.message || "Foto profile gagal diperbarui");
      }

      setProfilePhoto(response.data?.foto || photoDraft);
      setProfilePhotoVersion(Date.now());
      await getAllProfile(dispatch);
      setPhotoDraft("");
      setPhotoFile(null);
      setShowPhotoModal(false);
      Swal.fire("Berhasil", "Foto profile berhasil diperbarui", "success");
    } catch (error) {
      Swal.fire("Gagal", error.message || "Foto profile gagal diperbarui", "error");
    }
  };

  const profileSections = [
    {
      title: "Identitas",
      icon: "fa-id-card",
      items: [
        { label: "Nama", value: profileName, icon: "fa-user" },
        {
          label: "Nomor Pegawai",
          value: auth.nopeg || profile.nopeg || "-",
          icon: "fa-id-badge",
        },
        { label: "NIK", value: profile.nik || "-", icon: "fa-address-card" },
        { label: "Email", value: profile.email || "-", icon: "fa-envelope" },
        {
          label: "Nomor Telepon",
          value: profile.noTelp || "-",
          icon: "fa-phone",
        },
      ],
    },
    {
      title: "Informasi pekerjaan",
      icon: "fa-briefcase",
      items: [
        {
          label: "Status Karyawan",
          value: profile.statusKaryawan || "-",
          icon: "fa-user-check",
        },
        { label: "Jabatan", value: profile.jabatan || "-", icon: "fa-user-tie" },
        {
          label: "Perusahaan",
          value: profile.perusahaan?.namaPerusahaan || "-",
          icon: "fa-building",
        },
        {
          label: "Client",
          value: profile.client?.namaClient || "-",
          icon: "fa-sitemap",
        },
        {
          label: "Cabang",
          value: profile.cabang?.namaCabang || "-",
          icon: "fa-map-marker-alt",
        },
      ],
    },
    {
      title: "Informasi koperasi",
      icon: "fa-wallet",
      items: [
        {
          label: "Status Koperasi",
          value: koperasiStatus,
          icon: "fa-shield-alt",
          valueClass: `user-profile-value-status user-profile-value-status-${profile.statusKoperasi || "unknown"}`,
        },
        {
          label: "Nominal Simpanan",
          value: formatCurrency(profile.nominalSimpanan),
          icon: "fa-coins",
          valueClass: "user-profile-value-money",
        },
      ],
    },
  ];

  return (
    <>
      <Modal
        size="lg"
        show={showPhotoModal}
        onHide={() => {
          setPhotoDraft("");
          setPhotoFile(null);
          setShowPhotoModal(false);
        }}
        centered
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton className="user-profile-photo-modal-header">
          <Modal.Title>Ganti foto profile</Modal.Title>
        </Modal.Header>
        <Modal.Body className="user-profile-photo-modal-body">
          <label className="user-profile-photo-picker">
            {photoDraft ? (
              <img src={photoDraft} alt="Preview foto profile" />
            ) : (
              <i className="fas fa-cloud-upload-alt" />
            )}
            <span>{photoDraft ? "Ganti foto" : "Pilih foto"}</span>
            <Form.Control
              type="file"
              accept="image/png,image/jpeg,image/jpg,image/webp"
              onChange={handlePhotoChange}
            />
          </label>
          <p className="user-profile-photo-help">Format JPG, PNG, atau WEBP. Ukuran maksimal 1 MB.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setPhotoDraft("");
              setPhotoFile(null);
              setShowPhotoModal(false);
            }}
          >
            Batal
          </Button>
          <Button className="user-profile-save-photo" onClick={handleSavePhoto} disabled={!photoDraft}>
            Simpan foto
          </Button>
        </Modal.Footer>
      </Modal>

      <Container fluid className="user-profile-page">
        <div className="section-image user-profile-background" data-image="../../assets/img/bg5.jpg">
          {/* you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " */}
          <Row>
            <Col md="12">
              <Card className="user-profile-card">
                <Card.Header className="user-profile-header">
                  <button
                    type="button"
                    className="user-profile-avatar"
                    onClick={() => setShowPhotoModal(true)}
                    aria-label="Ganti foto profile"
                  >
                    {profilePhoto ? (
                      <img
                        src={`${profilePhoto}${profilePhoto.includes("?") ? "&" : "?"}v=${profilePhotoVersion}`}
                        alt={`Foto ${profileName}`}
                      />
                    ) : (
                      <i className="fas fa-user" />
                    )}
                    <span className="user-profile-avatar-action">
                      <i className="fas fa-camera" />
                      Ganti foto
                    </span>
                  </button>
                  <div className="user-profile-heading">
                    <span>Profil pengguna</span>
                    <h1>{profileName}</h1>
                    <p>
                      <i className="fas fa-id-badge" /> {auth.nopeg || profile.nopeg || "Nomor pegawai belum tersedia"}
                    </p>
                  </div>
                </Card.Header>
                <Card.Title as="h4" className="user-profile-section-title">
                  <span className="user-profile-section-kicker">Ringkasan</span>
                  Informasi akun
                  <small>Data akun dan keanggotaan koperasi Anda</small>
                </Card.Title>
                <Card.Body className="user-profile-body">
                  {profileSections.map((section) => (
                    <section className="user-profile-info-section" key={section.title}>
                      <div className="user-profile-info-heading">
                        <span className="user-profile-info-icon">
                          <i className={`fas ${section.icon}`} />
                        </span>
                        <h2>{section.title}</h2>
                      </div>
                      <div className="user-profile-info-grid">
                        {section.items.map((item) => (
                          <div className="user-profile-info-item" key={item.label}>
                            <span className="user-profile-item-icon">
                              <i className={`fas ${item.icon}`} />
                            </span>
                            <div className="user-profile-item-content">
                              <span className="user-profile-item-label">{item.label}</span>
                              <strong className={item.valueClass || ""}>{item.value}</strong>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default UserProfile;
